import { TextButton } from 'ui/button';
import { CampaignsErrorState } from 'ui/illustrations';
import { PlaceholderState } from 'ui/indexPages/PlaceholderState';

export const GoalsErrorState = () => (
  <PlaceholderState
    title="Oops! Issue loading goals"
    Illustration={CampaignsErrorState}
    data-test="goal-index-general-error-state"
  >
    We&apos;re having trouble loading your goals right now. Try refreshing the page, or{' '}
    <TextButton onClick={() => window?.adaEmbed?.toggle?.()}>reach out to support</TextButton> if
    the problem persists.
  </PlaceholderState>
);
